module.exports = __webpack_public_path__ + "static/media/map-marker.2e58c847.svg";